import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Button from '../Utils/Button';
import { restUrl } from '../../env';
import { WaitUntilLoggedIn } from '../Core/LoginManager';
import axios from 'axios';
import { gameStateManager } from '../../App';
import { Navigate } from "react-router-dom";
import PlayedGameRow from './PlayedGameRow';
import '../../css/bugReportRow.css';

export default class PlayedGames extends React.Component
{
  state = {
    playedGames: [],
    filters: {
      startDateTime: '',
      endDateTime: '',
      username: ''
    }
  };

  async componentDidMount()
  {
    await WaitUntilLoggedIn( async () =>
    {
      await this.updatePlayedGamesList();
    } );
  }

  async updatePlayedGamesList()
  {
    try
    {
      const { filters } = this.state;

      // Build the request body with only non-empty filters
      const requestBody = {};
      if( filters.startDateTime ) requestBody.startDateTime = filters.startDateTime;
      if( filters.endDateTime ) requestBody.endDateTime = filters.endDateTime;
      if( filters.username ) requestBody.username = filters.username;

      console.log( "PlayedGames: Making API request with filters:", requestBody );

      const response = await axios.post( `${restUrl}/admin/playedGames`, requestBody, { withCredentials: true } );

      console.log( "PlayedGames: API response:", response.data );

      if( response.data.success )
      {
        this.setState( { playedGames: response.data.data } );
        console.log( "PlayedGames: Updated state with", response.data.data.length, "games" );
      }
      else
      {
        console.log( "Failed to get admin playedGames: ", response.data.error );
      }
    }
    catch( error )
    {
      console.error( "PlayedGames: Error during API call:", error );
    }
  }

  handleFilterChange = ( field, value ) =>
  {
    this.setState( prevState => ( {
      filters: {
        ...prevState.filters,
        [ field ]: value
      }
    } ) );
  }

  clearFilters = () =>
  {
    this.setState( {
      filters: {
        startDateTime: '',
        endDateTime: '',
        username: ''
      }
    }, () =>
    {
      this.updatePlayedGamesList();
    } );
  }

  applyFilters = () =>
  {
    this.updatePlayedGamesList();
  }

  render()
  {
    return (
      <div style={ { height: '100%', display: 'flex', flexDirection: 'column' } }>
        <div className="bug-reports-header" style={ { flexShrink: 0 } }>
          <div className="header-title-section">
            <h4>Played Games</h4>
            <span className="results-count">
              { this.state.playedGames.length } result{ this.state.playedGames.length !== 1 ? 's' : '' } found
            </span>
          </div>
          <div className="filters-section">
            <Form onSubmit={ ( e ) =>
            {
              e.preventDefault();
              console.log( "PlayedGames: Form submission prevented" );
            } }>
              <Row className="mb-3">
                <Col md={ 3 }>
                  <Form.Group>
                    <Form.Label>Start Date/Time</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      value={ this.state.filters.startDateTime }
                      onChange={ ( e ) => this.handleFilterChange( 'startDateTime', e.target.value ) }
                    />
                  </Form.Group>
                </Col>
                <Col md={ 3 }>
                  <Form.Group>
                    <Form.Label>End Date/Time</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      value={ this.state.filters.endDateTime }
                      onChange={ ( e ) => this.handleFilterChange( 'endDateTime', e.target.value ) }
                    />
                  </Form.Group>
                </Col>
                <Col md={ 3 }>
                  <Form.Group>
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter username"
                      value={ this.state.filters.username }
                      onChange={ ( e ) => this.handleFilterChange( 'username', e.target.value ) }
                    />
                  </Form.Group>
                </Col>
                <Col md={ 3 } className="d-flex align-items-end gap-2">
                  <Button
                    type="button"
                    onClick={ () =>
                    {
                      console.log( "PlayedGames: Apply Filters clicked" );
                      this.applyFilters();
                    } }>
                    Apply Filters
                  </Button>
                  <Button
                    type="button"
                    className="secondary-button"
                    onClick={ () =>
                    {
                      console.log( "PlayedGames: Clear Filters clicked" );
                      this.clearFilters();
                    } }>
                    Clear
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
          <Button
            className="refresh-button"
            onClick={ () =>
            {
              this.updatePlayedGamesList();
            } }>
            Refresh
          </Button>
        </div>

        <div className="bug-reports-container">
          { this.state.playedGames.map( el => (
            <PlayedGameRow playedGameData={ el } key={ el.roomId + "" } />
          ) ) }

          { this.state.playedGames.length === 0 && (
            <div style={ { textAlign: 'center', padding: '40px', color: '#6c757d' } }>
              No played games found. Adjust filters or click refresh to check for games.
            </div>
          ) }
        </div>
      </div>
    );
  }
}
